// extracted by mini-css-extract-plugin
export var displayNone = "_pm-6";
export var imgContainer = "_pm-2";
export var overflowHidden = "_pm-3";
export var productInfoCardButtonContainer = "_pm-5";
export var productTitleText = "_pm-4";
export var rightArrow = "_pm-1";
export var rightArrowContainer = "_pm-0";